import React, {useEffect, useState, useRef} from "react";
import axios from "axios";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import alertify from "alertifyjs";
import {API_URL} from "../constants.js";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'


import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import {CKEditor} from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

export function EditReference(props) {
    const { t } = useTranslation();
    const name = useRef();
    const phone_no = useRef();
    const referral_rate = useRef();
    const notes = useRef();

    const [disabled, setDisabled] = useState(0);
    const [iconDisabled, setIconDisabled] = useState(1);
    const [references, setReferences] = useState({});
    const id = props.match.params.id;

    useEffect(() => {
        axios.get(API_URL + 'reference/' + id).then((response) => {
            if (response.data.status) {
                setReferences(response.data.data);

            } else {
                alertify.error(response.data.message);
                return null;
            }
        })
    }, []);

    const updateReferencesHandler = (e) => {
        e.preventDefault();
        setDisabled(1);
        setIconDisabled(0);
        axios.post(API_URL + "reference/update",
            {
                id: references.id,
                name: name.current.value,
                phone_no: phone_no.current.value,
                referral_rate: referral_rate.current.value,
                notes: notes.current.value,
            }
        ).then((response) => {
            setDisabled(0);
            setIconDisabled(1);
            if (response.data.status) {
                alertify.success(response.data.message);

                props.history.push("/reference/list");
            } else {
                alertify.error(response.data.message);
                return null;
            }
        }).catch((error) => {
            setDisabled(0);
            setIconDisabled(1);
            if (error.message === 'Request failed with status code 401') {
                //props.logout();
            }
        });
    }
    return (
        <Row>
            <Col md={12}>
                <Card>
                    <CardHeader title={t("Edit Reference")}>
                        <CardHeaderToolbar>
                            <Link to="/reference/list" className="btn btn-primary btn-sm mx-3">
                                {t("Reference List")}
                            </Link>
                        </CardHeaderToolbar>
                    </CardHeader>
                    <CardBody>

                        <div className="mt-5">
                            <Form onSubmit={updateReferencesHandler}>
                                <Form.Row>
                                    <Form.Group  className={'col-12 col-md-6'}>
                                        <Form.Label>{t("Name")}</Form.Label>
                                        <Form.Control ref={name} placeholder={t("Enter Reference Name")}
                                                      defaultValue={references.name}/>
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row>
                                    <Form.Group  className={'col-12 col-md-6'}>
                                        <Form.Label>{t("Phone No")}</Form.Label>
                                        <Form.Control  ref={phone_no} placeholder={t("Enter Reference Phone No")} rows={1}
                                                      defaultValue={references.phone_no}/>
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row>
                                    <Form.Group className={'col-12 col-md-6'}>
                                        <Form.Label>{t("Referral Rate")}</Form.Label>
                                        <Form.Control ref={referral_rate} placeholder={t("Referral Rate")}
                                                      defaultValue={references.referral_rate}/>
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row>
                                    <Form.Group className={'col-12 col-md-6'}>
                                        <Form.Label>{t("Notes")}</Form.Label>
                                        <Form.Control as="textarea" ref={notes} placeholder={t("Enter Reference Notes")} rows={1}
                                                      defaultValue={references.notes}/>
                                    </Form.Group>
                                </Form.Row>
                                <Button variant="primary" className="float-right" type="submit" disabled={disabled}>
                                    {t("Save")}
                                    <span
                                        dangerouslySetInnerHTML={{__html: disabled ? `<i class='fas fa-spinner fa-spin'></i>` : ``}}/>
                                </Button>
                            </Form>

                        </div>

                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
}